import { ComponentProps } from 'react';
import { Field } from '../Field';
import SelectElement from './SelectElement';

const Select = Field(SelectElement);

export type SelectFieldProps = ComponentProps<typeof Select>;

export default Select;
